import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { SpotlightCard } from '@atlaskit/onboarding';

const SpotlightCardDefaultExample = (): React.JSX.Element => {
	return (
		<SpotlightCard>
			Select the project name and icon to quickly switch between your most recent projects.
		</SpotlightCard>
	);
};

export default SpotlightCardDefaultExample;
